import React, { useState } from 'react';
import { createPortal } from 'react-dom';

const PageInfoModal = ({ title, items, light = false, compact = false }) => {
  const [show, setShow] = useState(false);

  const btnStyle = light
    ? {
        border: '1.5px solid #bfdbfe',
        background: '#dbeafe',
        color: '#fff',
        hoverBg: '#bfdbfe',
      }
    : {
        border: '1.5px solid var(--color-primary-border)',
        background: 'var(--color-primary-light)',
        color: 'var(--color-primary)',
        hoverBg: '#dbeafe',
      };

  const triggerBtn = (
    <button
      type="button"
      title="Bu səhifə haqqında məlumat"
      aria-label="Səhifə məlumatı"
      onClick={() => setShow(true)}
      style={{
        width: compact ? 32 : 34,
        height: compact ? 32 : 34,
        borderRadius: compact ? 8 : '50%',
        border: btnStyle.border,
        background: btnStyle.background,
        color: btnStyle.color,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        fontSize: compact ? 14 : 16,
        flexShrink: 0,
        transition: 'all 0.15s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = btnStyle.hoverBg;
        e.currentTarget.style.transform = compact ? 'translateY(-1px)' : 'scale(1.08)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = btnStyle.background;
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <i className="bi bi-info-circle-fill" />
    </button>
  );

  const modal = show && typeof document !== 'undefined' ? createPortal(
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 99999,
        background: '#0f172a',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: 16,
      }}
      onClick={() => setShow(false)}
      role="presentation"
    >
      <div
        style={{
          width: 560, maxWidth: '92vw', maxHeight: '85vh',
          display: 'flex', flexDirection: 'column',
          borderRadius: 14,
          border: '1px solid var(--color-border)',
          boxShadow: 'var(--shadow-lg)',
          overflow: 'hidden',
          background: '#fff',
        }}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          background: 'var(--color-surface)',
          borderBottom: '1px solid var(--color-border)',
          padding: '14px 20px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexShrink: 0,
        }}>
          <h6 style={{
            display: 'flex', alignItems: 'center', gap: 8,
            fontSize: 15, fontWeight: 700, color: 'var(--color-text)', margin: 0,
          }}>
            <span style={{
              width: 30, height: 30, borderRadius: 8, flexShrink: 0,
              background: 'var(--color-primary)',
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <i className="bi bi-info-circle-fill" style={{ color: '#fff', fontSize: 14 }} />
            </span>
            {title} — Nə edə bilərsiniz?
          </h6>
          <button
            type="button"
            onClick={() => setShow(false)}
            aria-label="Bağla"
            style={{
              background: 'none', border: 'none', fontSize: 22,
              lineHeight: 1, color: '#6b7280', cursor: 'pointer', padding: '0 4px',
            }}
          >×</button>
        </div>

        {/* Body */}
        <div style={{
          padding: '20px 24px',
          maxHeight: '65vh',
          overflowY: 'auto',
          background: 'var(--color-bg)',
        }}>
          <ol style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
            {items.map((item, idx) => (
              <li
                key={idx}
                style={{
                  display: 'flex', alignItems: 'flex-start', gap: 12,
                  background: '#fff',
                  border: '1px solid var(--color-border)',
                  borderRadius: 10,
                  padding: '12px 14px',
                  transition: 'box-shadow 0.18s',
                }}
              >
                <span style={{
                  flexShrink: 0, width: 26, height: 26, borderRadius: '50%',
                  background: 'var(--color-primary)',
                  color: '#fff', fontSize: 11, fontWeight: 700,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  marginTop: 1,
                }}>
                  {idx + 1}
                </span>
                <span style={{ fontSize: 13.5, lineHeight: 1.65, color: 'var(--color-text-secondary)' }}>
                  {item.icon && (
                    <i className={`bi bi-${item.icon}`} style={{ color: 'var(--color-primary)', marginRight: 7, fontSize: 14 }} />
                  )}
                  {item.text}
                </span>
              </li>
            ))}
          </ol>
        </div>

        {/* Footer */}
        <div style={{
          background: 'var(--color-surface)',
          borderTop: '1px solid var(--color-border)',
          padding: '12px 20px',
          display: 'flex', justifyContent: 'flex-end',
        }}>
          <button
            type="button"
            onClick={() => setShow(false)}
            style={{
              background: 'var(--color-primary)',
              border: 'none', borderRadius: 8,
              padding: '8px 28px',
              fontWeight: 600, fontSize: 13.5,
              color: '#fff', cursor: 'pointer',
              transition: 'background 0.15s',
            }}
            onMouseEnter={e => e.currentTarget.style.background = 'var(--color-primary-dark)'}
            onMouseLeave={e => e.currentTarget.style.background = 'var(--color-primary)'}
          >
            Anladım
          </button>
        </div>
      </div>
    </div>,
    document.body
  ) : null;

  return (
    <>
      {triggerBtn}
      {modal}
    </>
  );
};

export default PageInfoModal;
